import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

const MAX_WIDTH = 272;
function Wrapper({ children, sx }) {
    return jsx(Container, { sx: sx, children: children });
}
const Container = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateRows: "1fr auto",
    height: "100vh",
    maxWidth: MAX_WIDTH,
    backgroundColor: theme.palette.dui10,
}));

export { Container, Wrapper };
//# sourceMappingURL=Wrapper.js.map
